import { FormikField, P, Tooltip } from '@ahmdigital/ui';
import { useFormikContext } from 'formik';
import styled from 'styled-components';

import { RefinePriceSchemaType } from '../../../../../../features/refine-price/schema';
import getHasPartner from '../../../../../../pages/home/utils/get-has-partner';

const StyledSection = styled.section`
  flex-grow: 1;
`;

type AgeFieldProps = {
  isProductWithHospitalServices: boolean;
  hasSubmitAttempt: boolean;
  showTooltip?: boolean;
};

const AgeField = ({ showTooltip = true, isProductWithHospitalServices, hasSubmitAttempt }: AgeFieldProps) => {
  const { values } = useFormikContext<RefinePriceSchemaType>();
  const { scale } = values;
  const hasPartner = getHasPartner(scale);

  const tooltip = (
    <Tooltip>
      <P>
        Your age helps us calculate your Australian Government Rebate (AGR)
        {isProductWithHospitalServices && ' and any Youth Discount'}. The AGR applied to your policy is based on the
        oldest member’s age on your policy.
      </P>
    </Tooltip>
  );
  return (
    <StyledSection>
      <FormikField
        label="My age"
        name="age"
        size="auto"
        tooltip={showTooltip && tooltip}
        {...(hasSubmitAttempt ? { touched: hasSubmitAttempt } : {})}
        input={{
          inputMode: 'numeric',
          pattern: '[0-9]*',
        }}
        type="text"
      />
      {hasPartner && (
        <FormikField
          label="My partner’s age"
          name="partnerAge"
          input={{
            inputMode: 'numeric',
            pattern: '[0-9]*',
          }}
          {...(hasSubmitAttempt ? { touched: hasSubmitAttempt } : {})}
          type="text"
        />
      )}
    </StyledSection>
  );
};

export default AgeField;
